export default __webpack_public_path__ + "static/criminal-bg-fb82a76c056d10eab1a2c9c3ba456ed5.png";